// NO_MODIFY_THIS_FILE_BAKKA
// eslint-disable-next-line import/prefer-default-export
export const noop = () => {};
